import React, { useState, useEffect } from 'react'
import Layout from '../component/Layout'
import SubLayout from '../component/SubLayout'
import Header from '../component/Header'
import Container from '../component/Container'
import SmallLoader from '../component/SmallLoader'
import classes from './SubscribePage.module.css'
import { v4 as uuidv4 } from 'uuid';
import { useNavigate, useSearchParams } from 'react-router-dom'
import { subApi } from '../http/http'
import { useDispatch, useSelector } from 'react-redux'
import { setUserDetails } from '../store/slices/userSlice'
import { toast } from 'react-toastify'
import { FaCopyright } from 'react-icons/fa6'

const LoginPage = () => {

    const [msisdn, setMsisdn] = useState("");
    const [loginLoading, setLoginLoading] = useState(false);
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [extRef, setExtRef] = useState(null);
    const dispatch=useDispatch();

    const {userDetails}=useSelector(state=>state?.persisted?.userSlice);

    useEffect(()=>{
        if(userDetails?.token){
            navigate("/home");
        }
    },[userDetails]);

    useEffect(() => {
        if (searchParams.get("ext_ref")) {
            setExtRef(searchParams.get("ext_ref"));
        } else {
            setSearchParams({ ext_ref: uuidv4() });
        }
    }, [searchParams]);
    const handleFormSubmission = async (e) => {
        try {
            e.preventDefault();
            if (msisdn?.trim().length == 0) {
                return;
            }
            setLoginLoading(true);

            const response=await subApi(msisdn);
            console.log(response, 'response');
            dispatch(setUserDetails(response?.data));
            setLoginLoading(false);
            toast.success("Login Successfully!");
            navigate("/home");
        } catch (error) {
            setLoginLoading(false);
            console.log(error, 'error');
            toast.error(error?.response?.data?.message || error?.response?.message || error?.data?.message || "Something Went Wrong!");
        }
    }

    return (
        <Layout>
            <SubLayout>
                <Header hide={true} />
                <Container>
                    <h1 className={classes.heading}>
                        <span className={classes.highlight}>UVFootball XI {" "}</span>
                        is an exciting fantasy football platform where you can build your dream team, make predictions on real matches, and compete with others to win big!
                    </h1>

                    <div className={classes.actions_box_container}>
                        <div className={classes.actions_box}>
                            <button className={`${classes.action_box} ${classes.active}`}
                                type='button'
                            >
                                Login
                            </button>
                            <button className={`${classes.action_box}`}
                                onClick={() => navigate(`/?ext_ref=${extRef}`)}
                            >
                                Subscribe
                            </button>
                        </div>
                    </div>

                    <form className={classes.form} onSubmit={handleFormSubmission}
                    >
                        <div className={classes.username_field_form}>
                            <div className={classes.country_code}>
                                <img src="/assets/images/cameroon.png" alt="flag" className={classes.flag} />
                                <p className={classes.country_code_number}>+237</p>
                            </div>
                            <input
                                id="msisdn"
                                name="msisdn"
                                type="number"
                                onWheel={(e) => e.target.blur()}
                                autoFocus placeholder={"Enter your phone number"} className={classes.input_field_username}
                                onChange={(e) => {
                                    setMsisdn(e.target.value)
                                }}
                                value={msisdn}
                            />
                        </div>

                        <div className={classes.check_box_container}>
                            <input type="checkbox" id="terms" name="Terms & Conditions" value="Terms"
                                className={classes.check_box} checked
                            >
                            </input>
                            <label for="terms" className={classes.check_box_label}>
                                By Continuing, you agree to our <span className={classes.terms_conditions}>Terms & Conditions</span>
                            </label>
                        </div>



                        <button type="submit"
                            disabled={loginLoading}
                            className={classes.login_btn}>{
                                loginLoading ? <SmallLoader style={{ border: "5px solid #fff" }} /> : "Continue"
                            }</button>

                        {/* <div className={classes.footer}> */}
                        {/* </div> */}
                    </form>

                    <div className={classes.footer_container}>
                        <FaCopyright className={classes.copyright_icon} />
                        <p className={classes.copyright_text}>
                            Rainboo Softmate Pvt Ltd
                            </p>
                    </div>

                </Container>
            </SubLayout>
        </Layout>
    )
}

export default LoginPage